module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Roller-a71d9e2b09e6de1240801cda73c1d755089e1eeb7fb9c8260981c0d4ae7efb30.svg";